const EVENTS = {
  ADD_SONGS_TO_PLAYER_PLAYLIST: 'ADD_SONGS_TO_PLAYER_PLAYLIST',
  ADD_SONGS_TO_PLAYER_PLAYLIST_START_AT: 'ADD_SONGS_TO_PLAYER_PLAYLIST_START_AT',
  ADD_SPOT_COUNT: 'ADD_SPOT_COUNT',
  ENABLE_SPOT: 'ENABLE_SPOT',
  NOTIFY_SKIP: 'NOTIFY_SKIP',
  PLAY_RADIO: 'PLAY_RADIO',
  RESET_REPEAT: 'RESET_REPEAT',
  REPEAT_CURRENT_SONG: 'REPEAT_CURRENT_SONG',
  SET_FIRST_PLAY: 'SET_FIRST_PLAY',
  SET_FREEPLAYLIST_ID: 'SET_FREEPLAYLIST_ID',
  SET_PLAYING_SPOT: 'SET_PLAYING_SPOT',
  TOGGLE_REPEAT: 'TOGGLE_REPEAT',
  TOGGLE_SHUFFLE: 'TOGGLE_SHUFFLE',
  UPDATE_CURRENT_CONTENT: 'UPDATE_CURRENT_CONTENT',
  UPDATE_FAV_STATUS_CONTENT: 'UPDATE_FAV_STATUS_CONTENT',
  UPDATE_FAV_STATUS_PLAYLIST : 'UPDATE_FAV_STATUS_PLAYLIST',
  UPDATE_PLAY_CONTROL: 'UPDATE_PLAY_CONTROL',
  UPDATE_PLAYER_DATA: 'UPDATE_PLAYER_DATA',
  UPDATE_SKIPS: 'UPDATE_SKIPS',
  TOGGLE_SPOT: 'TOGGLE_SPOT',
  OLD_CURRENT_TIME: 'OLD_CURRENT_TIME',
  DELETE_OLD_CURRENT_CONTENT: 'DELETE_OLD_CURRENT_CONTENT',
  UPDATE_FLAG_STATUS: 'UPDATE_FLAG_STATUS',
};

module.exports = EVENTS;



// WEBPACK FOOTER //
// ./src/actions/musica/playermusica.js